import { Box, Button, Stack, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { FeedLoader } from "../../../components/generic/GenericLoader";
import { CreatorCard } from "./CreatorCard";
import { TOP_CREATOR_FEED_WIDTH } from "../../../enums/themeEnum";
import { useTheme } from "@emotion/react";

export const TopCreatorsLayout = ({ creators, isLoading, handleViewAll, tagName = 'Collab', tagType = 'Top', lazyLoad }) => {

  const theme = useTheme();

  const SectionHeader = ({ ...others }) => {
    return <Typography {...others} variant="h2" fontSize={'1.5em'} fontWeight={700} textTransform={'uppercase'}>{tagType} <span style={{ color: theme.palette.primary.main }}>{tagName}</span> CREATORS</Typography>;
  };

  const SectionViewButton = () => {
    return <Button variant="outlined" onClick={() => handleViewAll()} fullWidth>View All</Button>;
  };

  return (
    <Fragment>
      <Box display={{ xs: 'flex-column', sm: 'none' }} mb={2}>
        <SectionHeader mb={1} />
        <Box sx={{
          mb: 2,
          overflowY: 'auto',
          '&::-webkit-scrollbar': { display: 'none' }
        }}
        >
          <Stack direction={'row'} gap={2}>
            {
              isLoading ? <FeedLoader /> : creators?.map((creator, index) => {
                return (
                  <Box key={`creator-key-${index}`}>
                    <CreatorCard creator={creator} width={'250px'} />
                  </Box>
                );
              })
            }
          </Stack>
        </Box>
        <SectionViewButton />
      </Box>
      <Box
        display={{ xs: 'none', sm: 'flex' }}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        mb={1}
      >
        <Box sx={{ width: TOP_CREATOR_FEED_WIDTH }}>
          <Box sx={{ width: '100%' }}>
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={1}>
              <SectionHeader />
              <Box display={{ xs: 'none', mds: 'flex' }}>
                <SectionViewButton />
              </Box>
            </Stack>
          </Box>
          <Box
            display="inline-flex"
            flexDirection="row"
            flexWrap="wrap"
            gap={'14px'}
            sx={{
              justifyContent: 'flex-start',
            }}
          >
            {
              isLoading ? <FeedLoader count={10} /> :
                <Fragment>
                  {
                    creators?.map((creator, index) => {
                      return (
                        <CreatorCard key={`creator-key-${index}`} creator={creator} lazyLoad={lazyLoad}/>
                      );
                    })
                  }
                </Fragment>
            }
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};